export default {"src":"/_next/static/media/become-security-icons.24b8fee2.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};